<template>
  <div>
    <search-list @searchData="search"></search-list>
    <div class="page-wrapper" style="padding-top: 0">
      <Button type="primary" v-p="{api:'formula/saveFormula'}" @click.stop="addN++" class="mb16">新增</Button>
      <table-list
        :columns="columns"
        :data="data"
        :current="current"
        :total="total"
        :loading="loading"
        @change-page="changPage"
      ></table-list>
      <add :n="addN"
           @done="formulaListByPage"
      ></add>
      <modify
      :n="addM"
      :formulaFid="formulaFid"
      @done="formulaListByPage"
      ></modify>
      
    </div>
  </div>

</template>

<script>
  import SearchList from './components/SearchList'
  import TableList from 'components/TableList/index';
  import Add from './components/Add'
  import Modify from './components/Modify'

  import {formulaListByPage,deleteFormula,allFormula} from "../../../../api/performula";
  import {allMeta} from "../../../../api/meta";
import {formatDateTime} from "../../../../utils/format";

  export default {
    name: "performula",
    components: {
      SearchList,
      TableList,
      Add,
      Modify,
    },
    created(){
    },
    data(){
      return {
        addN:0,
        addM:0,
        data: [],
        formulaFid:'',
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: ' '
          },
          {
            title: '机构名称 ',
            align: 'center',
            key: 'orgName',
            width: 160,
          },
          {
            title: ' '
          },
          {
            title: '公式名 ',
            align: 'center',
            key: 'formulaName',
            width: 160,
          },
          {
            title: ' '
          },
          {
            title: '表达式 ',
            align: 'center',
            key: 'expStr',
            width: 320,
            // render:(h,params)=>{
            //   return h('a',{
            //     on:{
            //       click:()=>{
            //         let query = {
            //           fid: params.row['fid'],
            //         };
            //         this.$router.push({name:'personbookinfo',query:query})
            //       }
            //     }
            //   },params.row['fcode'])
            // }
          },
          {
            title: ' '
          },
          {
            title: "创建人",
            align: 'center',
            key: 'createBy',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '创建时间',
            align: 'center',
            key: 'createTime',
            width: 160,
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['createTime']))
            }
            // render:(h,params)=>{
            //   let maps={'1':'已超期','2':'待支付','3':'待签约','4':'已签约','5':'客户违约','6':'公司违约','7':'已取消' }
            //   return h('span',{},maps[params.row['reservationStatus']+''])
            // }
          },
          {
            title: ' '
          },
          {
            title: '操作',
            align: 'center',
            key: 'action',
            width: 170,
            fixed: 'right',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'formula/updateFormula'
                      }
                    }
                  ],
                  style: {
                    marginRight: '10px',
                  },
                  on: {
                    click: () => {
                      this.addM ++;
                      this.formulaFid = params.row['formulaFid']
                    }
                  }
                }, '修改'),
                h('a', {
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'formula/deleteFormula'
                      }
                    }
                  ],
                  style: {
                    marginRight: '5px',
                    // display: params.row.reservationStatus === 2 ?'inline-block' :'none'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '删除公式',
                        content: '<p>确定删除此公式？？</p>',
                        onOk: () => {
                          let params1={
                            formulaFid:params.row['formulaFid']
                          }
                            deleteFormula(params1).then(res=>{
                              this.$Message.success('操作成功')
                              this.page=1
                              this.current=1
                              this.formulaListByPage()
                            }).catch(error=>{
                              this.$Message.info('操作失败')})
                        }
                      })
                    }
                  }
                }, '删除'),
              ])
            }
          }
        ],
        total: 0,
        current: 1,
        loading: false,
        searchParams:null,
        page:1,
        limit:10,
        metaList:[],
        formulaList:[]

      }
    },
    methods:{


      search(data){
        this.page=1
        this.current=1
        this.searchParams=data
        this.formulaListByPage()

      },
      formulaListByPage(){
        let params={
          ...this.searchParams,
          page:this.page,
          limit:this.limit
        }
        formulaListByPage(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total
          res.data.rows&& (this.data=res.data.rows)

        }).catch(error=>{
        })
      },
      changPage(n){
        this.current = n;
        this.page = n;
        this.formulaListByPage()
      },
    }
  }
</script>

<style scoped>

</style>
